import axios, { AxiosHeaders, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'; // Certifique-se de importar corretamente
import CryptoJS from 'crypto-js';
import { LOCAL_STORAGE_KEYS } from '../localstorage/LocalStorage.keys';
import { Company } from '../models/Company';
import { User } from '../models/User';

interface InternalAxiosRequestConfig extends AxiosRequestConfig {
  headers: AxiosHeaders;
}

interface UserData extends User {
  token: string;
  empresa: Company;
}

export const decryptUserData = () => {
  try {
    let tokenStorage = localStorage.getItem(LOCAL_STORAGE_KEYS.USER);
    if (tokenStorage) {
      const secretKey = process.env.REACT_APP_CRYPTO_KEY;
      return JSON.parse(CryptoJS.AES.decrypt(tokenStorage, secretKey!).toString(CryptoJS.enc.Utf8)) as UserData;
    }
  } catch (error) {
    throw new Error('Erro ao descriptografar o usuário');
  }
};

const createAxiosInstance = () => {
  const endpoint = process.env.REACT_APP_API_URL;

  const axiosInstance: AxiosInstance = axios.create({
    baseURL: endpoint || ''
  });

  axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      let user: UserData | null = null;

      try {
        user = decryptUserData();
      } catch (error: any) {
        console.log('Sem autorização', error);
      }

      if (user && config) {
        config.headers['X-Token'] = user.api_token;
        config.headers['X-Usuario'] = user.token;
        config.headers['X-Empresa'] = user.empresa.api_token;
      }

      return config;
    },
    (error: any) => {
      console.log('error', error);
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      if (response.status === 401 && window.location.pathname !== '/login') {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
        window.location.href = '/login';
        return Promise.reject(response);
      } else if (response.status >= 200 && response.status < 300) {
        return response;
      } else {
        return Promise.reject(response);
      }
    },
    (error: any) => {
      console.log('error', error);
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;
